import api from "../../plugins/api";
import { logger } from "../services/LoggerService";
/**
 * API implementation of User Preferences Repository
 *
 * Persists user theme preferences via the BFF AccountPreference controller,
 * which proxies requests to OPREF.
 */
export class ApiUserPreferencesRepository {
    /**
     * Get theme preference from BFF (proxied to OPREF).
     * Response: the BFF ApiResponse<string> envelope, { success, data: "light" | "dark" | "" }.
     */
    async getTheme() {
        try {
            const response = await api.get("/account-preference/theme", { apiType: "bff" });
            logger.debug("[ApiUserPreferencesRepository] Retrieved theme from API:", response.data);
            const themeValue = response.data?.data;
            if (themeValue === "dark") {
                return "dark";
            }
            return "light";
        }
        catch (error) {
            logger.debug("[ApiUserPreferencesRepository] Error reading theme from API:", error);
            return "light";
        }
    }
    /**
     * Update theme preference via BFF (proxied to OPREF).
     * @param theme - Theme to set ("light" or "dark")
     */
    async updateTheme(theme) {
        try {
            await api.put("/account-preference/theme", { theme }, { apiType: "bff" });
            logger.debug("[ApiUserPreferencesRepository] Updated theme via API:", theme);
        }
        catch (error) {
            logger.debug("[ApiUserPreferencesRepository] Error updating theme via API:", error);
            throw error;
        }
    }
}
